import { useContext, useMemo } from 'react';
import useAppSelector from 'hooks/useAppSelector';
import CalendarContext from '../../CalendarContext';
import { CalendarLead } from '../../Calendar.types';

// Unique leads in a property row — lets LeadView mount at the row level so it stays put across column virtualization.
const useLeadsForProperty = (propertyUid: string): CalendarLead[] => {
  const { leadsMap } = useContext(CalendarContext);
  const propertyEntries = useAppSelector(
    (state) => state.stackedCalendar.propertiesEntries[propertyUid],
  );

  return useMemo(() => {
    if (!propertyEntries) {
      return [];
    }

    const seen = new Set<string>();
    const leads: CalendarLead[] = [];
    Object.values(propertyEntries).forEach((entry) => {
      entry.leads?.forEach((uid) => {
        if (seen.has(uid)) {
          return;
        }
        seen.add(uid);
        const lead = leadsMap[uid];
        if (lead) {
          leads.push(lead);
        }
      });
    });
    return leads;
  }, [propertyEntries, leadsMap]);
};

export default useLeadsForProperty;
